import React, { Component } from "react";
import { Link } from "react-router-dom";
import propTypes from "prop-types";
import { confirmAlert } from "react-confirm-alert";
import DateFormat from "../../helpers/DateFormat";

export default class extends Component {
  static propTypes = {
    canBeDelete: propTypes.bool.isRequired,
    deleteAction: propTypes.func,
    index: propTypes.number.isRequired
  };

  deleteOnClick = () => {
    const { film, index, deleteAction } = this.props;
    confirmAlert({
      title: "Удаление",
      message: `Вы действительно хотите удалить ${(film && film.title) ||
        "фильм"}`,
      buttons: [
        {label: "Отмена"},
        {
          label: "Подтверждаю",
          onClick: () => deleteAction(index)
        }
      ]
    });
  };

  renderDeleteButton() {
    if (this.props.canBeDelete) {
      return (
        <div className="schedule-upload__item__controls">
          <a
            className="schedule-upload__item__btn-gray"
            onClick={this.deleteOnClick}
          >
            Удалить
          </a>
        </div>
      );
    }
    return "";
  }

  render() {
    const { id, film, dateBegin, dateEnd, times } = this.props;
    return (
      <tr>
        <td className="large-column" colSpan="3">
          <div className="schedule-upload__item__name">
            {film && film.title}
          </div>
          <div className="schedule-upload__item__date-range">
            {DateFormat.getRange(
              DateFormat.dateFromEpoch(dateBegin),
              DateFormat.dateFromEpoch(dateEnd)
            )}
          </div>
        </td>
        <td className="small-column">
          <div className="flex-inline">
            <div className="schedule-upload__item__session-time">
              {(times || []).join(", ")}
            </div>
            <div className="schedule-upload__item__controls">
              <Link
                to={`/schedule/update/${id}`}
                className="schedule-upload__item__btn-blue"
              >
                Редактировать
              </Link>
              {this.renderDeleteButton()}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/schedule/_item.jsx